/* tslint:disable */
/* eslint-disable */
/**
 *
 * @export
 * @interface CloseInfo
 */
export interface CloseInfo {
  /**
   *
   * @type {string}
   * @memberof CloseInfo
   */
  closePrice: string;
  /**
   *
   * @type {string}
   * @memberof CloseInfo
   */
  fundingFee: string;
  /**
   *
   * @type {string}
   * @memberof CloseInfo
   */
  closeFee: string;
  /**
   *
   * @type {string}
   * @memberof CloseInfo
   */
  pnl: string;
  /**
   *
   * @type {string}
   * @memberof CloseInfo
   */
  holdingFee: string;
  /**
   *
   * @type {number}
   * @memberof CloseInfo
   */
  closeTime: number;
}
/**
 *
 * @export
 * @interface ClosePositionDetail
 */
export interface ClosePositionDetail {
  /**
   *
   * @type {string}
   * @memberof ClosePositionDetail
   */
  executionType?: ClosePositionDetailExecutionTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ClosePositionDetail
   */
  closePrice: string;
  /**
   *
   * @type {string}
   * @memberof ClosePositionDetail
   */
  fundingFee: string;
  /**
   *
   * @type {string}
   * @memberof ClosePositionDetail
   */
  closeFee: string;
  /**
   *
   * @type {string}
   * @memberof ClosePositionDetail
   */
  holdingFee: string;
  /**
   *
   * @type {string}
   * @memberof ClosePositionDetail
   */
  pnl: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ClosePositionDetailExecutionTypeEnum {
  Tp = 'TP',
  Sl = 'SL',
  Liq = 'LIQ',
  Adl = 'ADL',
}

/**
 *
 * @export
 * @interface EpochTrading
 */
export interface EpochTrading {
  /**
   *
   * @type {number}
   * @memberof EpochTrading
   */
  epoch: number;
  /**
   *
   * @type {string}
   * @memberof EpochTrading
   */
  volumeUSD: string;
}
/**
 *
 * @export
 * @interface JoinTradingCompetitionRequest
 */
export interface JoinTradingCompetitionRequest {
  /**
   *
   * @type {string}
   * @memberof JoinTradingCompetitionRequest
   */
  trader: string;
  /**
   *
   * @type {string}
   * @memberof JoinTradingCompetitionRequest
   */
  inviteCode: string;
}
/**
 *
 * @export
 * @interface LatestPairPriceFailure
 */
export interface LatestPairPriceFailure {
  /**
   *
   * @type {string}
   * @memberof LatestPairPriceFailure
   */
  pairBase: string;
  /**
   *
   * @type {string}
   * @memberof LatestPairPriceFailure
   */
  reason: string;
}
/**
 *
 * @export
 * @interface LatestPairPricesRequest
 */
export interface LatestPairPricesRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof LatestPairPricesRequest
   */
  pairBases: Array<string>;
  /**
   *
   * @type {string}
   * @memberof LatestPairPricesRequest
   */
  blockChain: LatestPairPricesRequestBlockChainEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum LatestPairPricesRequestBlockChainEnum {
  Monad = 'MONAD',
}

/**
 *
 * @export
 * @interface LatestPairPricesResponse
 */
export interface LatestPairPricesResponse {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof LatestPairPricesResponse
   */
  prices: { [key: string]: string };
  /**
   *
   * @type {Array<LatestPairPriceFailure>}
   * @memberof LatestPairPricesResponse
   */
  failures: Array<LatestPairPriceFailure>;
}
/**
 *
 * @export
 * @interface LeaderboardDataResponse
 */
export interface LeaderboardDataResponse {
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  rank: number;
  /**
   *
   * @type {string}
   * @memberof LeaderboardDataResponse
   */
  userAddress: string;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  pnl: number;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  totalVolUsd: number;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  winCount: number;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  loseCount: number;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  biggestWin: number;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  winRate: number;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  totalCount: number;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  highLeverageVolUsd: number;
  /**
   *
   * @type {number}
   * @memberof LeaderboardDataResponse
   */
  lowLeverageVolUsd: number;
}
/**
 *
 * @export
 * @interface LeaderboardHeader
 */
export interface LeaderboardHeader {
  /**
   *
   * @type {string}
   * @memberof LeaderboardHeader
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof LeaderboardHeader
   */
  label: string;
}
/**
 *
 * @export
 * @interface LimitOrderPositionDetail
 */
export interface LimitOrderPositionDetail {
  /**
   *
   * @type {string}
   * @memberof LimitOrderPositionDetail
   */
  tokenIn: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderPositionDetail
   */
  amountIn: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderPositionDetail
   */
  price: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderPositionDetail
   */
  takeProfit: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderPositionDetail
   */
  stopLoss: string;
}
/**
 *
 * @export
 * @interface LimitOrderResponse
 */
export interface LimitOrderResponse {
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  orderHash: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  pair?: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  pairBase: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  trader: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  userAddress: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  tokenIn: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  marginToken: string;
  /**
   *
   * @type {boolean}
   * @memberof LimitOrderResponse
   */
  isLong: boolean;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  amountIn: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  qty?: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  price?: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  stopLoss?: string;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  takeProfit?: string;
  /**
   *
   * @type {number}
   * @memberof LimitOrderResponse
   */
  timestamp: number;
  /**
   *
   * @type {string}
   * @memberof LimitOrderResponse
   */
  status: LimitOrderResponseStatusEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum LimitOrderResponseStatusEnum {
  Executed = 'EXECUTED',
  Cancelled = 'CANCELLED',
  Open = 'OPEN',
  Executing = 'EXECUTING',
}

/**
 *
 * @export
 * @interface MarketOrderPositionDetail
 */
export interface MarketOrderPositionDetail {
  /**
   *
   * @type {string}
   * @memberof MarketOrderPositionDetail
   */
  collateral: string;
  /**
   *
   * @type {string}
   * @memberof MarketOrderPositionDetail
   */
  positionSize: string;
  /**
   *
   * @type {string}
   * @memberof MarketOrderPositionDetail
   */
  atPrice: string;
  /**
   *
   * @type {string}
   * @memberof MarketOrderPositionDetail
   */
  executionFee: string;
}
/**
 *
 * @export
 * @interface MarketPendingDetail
 */
export interface MarketPendingDetail {
  /**
   *
   * @type {string}
   * @memberof MarketPendingDetail
   */
  tokenIn: string;
  /**
   *
   * @type {string}
   * @memberof MarketPendingDetail
   */
  amountIn: string;
  /**
   *
   * @type {string}
   * @memberof MarketPendingDetail
   */
  price: string;
  /**
   *
   * @type {string}
   * @memberof MarketPendingDetail
   */
  stopLoss: string;
  /**
   *
   * @type {string}
   * @memberof MarketPendingDetail
   */
  takeProfit: string;
  /**
   *
   * @type {string}
   * @memberof MarketPendingDetail
   */
  broker: string;
}
/**
 *
 * @export
 * @interface Metrics
 */
export interface Metrics {
  /**
   *
   * @type {number}
   * @memberof Metrics
   */
  positionLiveCount: number;
  /**
   *
   * @type {number}
   * @memberof Metrics
   */
  orderLiveCount: number;
  /**
   *
   * @type {number}
   * @memberof Metrics
   */
  orderCancelCount: number;
  /**
   *
   * @type {number}
   * @memberof Metrics
   */
  positionCloseCount: number;
  /**
   *
   * @type {number}
   * @memberof Metrics
   */
  positionTpCount: number;
  /**
   *
   * @type {number}
   * @memberof Metrics
   */
  positionSlCount: number;
  /**
   *
   * @type {number}
   * @memberof Metrics
   */
  positionLiqCount: number;
}
/**
 *
 * @export
 * @interface OracleBatchPriceResponse
 */
export interface OracleBatchPriceResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof OracleBatchPriceResponse
   */
  pythPriceUpdateData?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof OracleBatchPriceResponse
   */
  pythProPriceUpdateData?: Array<string>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof OracleBatchPriceResponse
   */
  pythCoreUpdateDataById?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof OracleBatchPriceResponse
   */
  pythProUpdateDataById?: { [key: string]: Array<string> };
  /**
   *
   * @type {string}
   * @memberof OracleBatchPriceResponse
   */
  updateFee?: string;
  /**
   *
   * @type {string}
   * @memberof OracleBatchPriceResponse
   */
  verifition_fee?: string;
  /**
   *
   * @type {string}
   * @memberof OracleBatchPriceResponse
   */
  pythCoreSingleUpdateFeeWei?: string;
  /**
   *
   * @type {string}
   * @memberof OracleBatchPriceResponse
   */
  pythCoreTransactionFeeWei?: string;
  /**
   *
   * @type {string}
   * @memberof OracleBatchPriceResponse
   */
  pythProVerificationFeeWei?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof OracleBatchPriceResponse
   */
  pythCorePrice?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof OracleBatchPriceResponse
   */
  pythCorePublishTime?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof OracleBatchPriceResponse
   */
  pythProPrice?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof OracleBatchPriceResponse
   */
  pythProPublishTime?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof OracleBatchPriceResponse
   */
  dexOraclePrice?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof OracleBatchPriceResponse
   */
  dexOraclePublishTime?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof OracleBatchPriceResponse
   */
  pythCorePriceSafe?: { [key: string]: boolean };
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof OracleBatchPriceResponse
   */
  pythProPriceSafe?: { [key: string]: boolean };
  /**
   *
   * @type {Array<OracleFailure>}
   * @memberof OracleBatchPriceResponse
   */
  failures: Array<OracleFailure>;
}
/**
 *
 * @export
 * @interface OracleFailure
 */
export interface OracleFailure {
  /**
   *
   * @type {OracleIdInput}
   * @memberof OracleFailure
   */
  oracleId: OracleIdInput;
  /**
   *
   * @type {string}
   * @memberof OracleFailure
   */
  reason: string;
  /**
   *
   * @type {string}
   * @memberof OracleFailure
   */
  component: OracleFailureComponentEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum OracleFailureComponentEnum {
  Price = 'PRICE',
  Payload = 'PAYLOAD',
  PayloadById = 'PAYLOAD_BY_ID',
}

/**
 *
 * @export
 * @interface OracleHistoryPricePoint
 */
export interface OracleHistoryPricePoint {
  /**
   *
   * @type {string}
   * @memberof OracleHistoryPricePoint
   */
  price: string;
  /**
   *
   * @type {number}
   * @memberof OracleHistoryPricePoint
   */
  publishTime: number;
  /**
   *
   * @type {number}
   * @memberof OracleHistoryPricePoint
   */
  capturedAt: number;
}
/**
 *
 * @export
 * @interface OracleIdInput
 */
export interface OracleIdInput {
  /**
   *
   * @type {string}
   * @memberof OracleIdInput
   */
  kind: OracleIdInputKindEnum;
  /**
   *
   * @type {string}
   * @memberof OracleIdInput
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof OracleIdInput
   */
  oracle?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum OracleIdInputKindEnum {
  None = 'NONE',
  PythCore = 'PYTH_CORE',
  PythPro = 'PYTH_PRO',
  DexOracle = 'DEX_ORACLE',
}

/**
 *
 * @export
 * @interface OracleResponseOptions
 */
export interface OracleResponseOptions {
  /**
   *
   * @type {boolean}
   * @memberof OracleResponseOptions
   */
  includeEncodingData: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OracleResponseOptions
   */
  includeFee: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OracleResponseOptions
   */
  includePrice: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OracleResponseOptions
   */
  includePublishTime: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OracleResponseOptions
   */
  includePriceSafety: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OracleResponseOptions
   */
  includeEncodingDataByOracleId: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OracleResponseOptions
   */
  allowPartial: boolean;
}
/**
 *
 * @export
 * @interface PagedLeaderboardDataResponse
 */
export interface PagedLeaderboardDataResponse {
  /**
   *
   * @type {Array<LeaderboardDataResponse>}
   * @memberof PagedLeaderboardDataResponse
   */
  content: Array<LeaderboardDataResponse>;
  /**
   *
   * @type {number}
   * @memberof PagedLeaderboardDataResponse
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedLeaderboardDataResponse
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedLeaderboardDataResponse
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedLeaderboardDataResponse
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PagedLimitOrderResponse
 */
export interface PagedLimitOrderResponse {
  /**
   *
   * @type {Array<LimitOrderResponse>}
   * @memberof PagedLimitOrderResponse
   */
  content: Array<LimitOrderResponse>;
  /**
   *
   * @type {number}
   * @memberof PagedLimitOrderResponse
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedLimitOrderResponse
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedLimitOrderResponse
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedLimitOrderResponse
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PagedPairResponse
 */
export interface PagedPairResponse {
  /**
   *
   * @type {Array<PairResponse>}
   * @memberof PagedPairResponse
   */
  content: Array<PairResponse>;
  /**
   *
   * @type {number}
   * @memberof PagedPairResponse
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedPairResponse
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedPairResponse
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedPairResponse
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PagedPositionResponse
 */
export interface PagedPositionResponse {
  /**
   *
   * @type {Array<PositionResponse>}
   * @memberof PagedPositionResponse
   */
  content: Array<PositionResponse>;
  /**
   *
   * @type {number}
   * @memberof PagedPositionResponse
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedPositionResponse
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedPositionResponse
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedPositionResponse
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PagedTeamLeaderboardItem
 */
export interface PagedTeamLeaderboardItem {
  /**
   *
   * @type {Array<TeamLeaderboardItem>}
   * @memberof PagedTeamLeaderboardItem
   */
  content: Array<TeamLeaderboardItem>;
  /**
   *
   * @type {number}
   * @memberof PagedTeamLeaderboardItem
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedTeamLeaderboardItem
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedTeamLeaderboardItem
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedTeamLeaderboardItem
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PagedTeamMemberInfo
 */
export interface PagedTeamMemberInfo {
  /**
   *
   * @type {Array<TeamMemberInfo>}
   * @memberof PagedTeamMemberInfo
   */
  content: Array<TeamMemberInfo>;
  /**
   *
   * @type {number}
   * @memberof PagedTeamMemberInfo
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedTeamMemberInfo
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedTeamMemberInfo
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedTeamMemberInfo
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PagedTradeHistoryResponse
 */
export interface PagedTradeHistoryResponse {
  /**
   *
   * @type {Array<TradeHistoryResponse>}
   * @memberof PagedTradeHistoryResponse
   */
  content: Array<TradeHistoryResponse>;
  /**
   *
   * @type {number}
   * @memberof PagedTradeHistoryResponse
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedTradeHistoryResponse
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedTradeHistoryResponse
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedTradeHistoryResponse
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PagedTradingCompetitionLeaderboardItem
 */
export interface PagedTradingCompetitionLeaderboardItem {
  /**
   *
   * @type {Array<TradingCompetitionLeaderboardItem>}
   * @memberof PagedTradingCompetitionLeaderboardItem
   */
  content: Array<TradingCompetitionLeaderboardItem>;
  /**
   *
   * @type {number}
   * @memberof PagedTradingCompetitionLeaderboardItem
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedTradingCompetitionLeaderboardItem
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedTradingCompetitionLeaderboardItem
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedTradingCompetitionLeaderboardItem
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PagedUserTeamBoostHistory
 */
export interface PagedUserTeamBoostHistory {
  /**
   *
   * @type {Array<UserTeamBoostHistory>}
   * @memberof PagedUserTeamBoostHistory
   */
  content: Array<UserTeamBoostHistory>;
  /**
   *
   * @type {number}
   * @memberof PagedUserTeamBoostHistory
   */
  pageNumber: number;
  /**
   *
   * @type {number}
   * @memberof PagedUserTeamBoostHistory
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof PagedUserTeamBoostHistory
   */
  totalPages: number;
  /**
   *
   * @type {number}
   * @memberof PagedUserTeamBoostHistory
   */
  totalElements: number;
}
/**
 *
 * @export
 * @interface PairHoursAgoPriceResponse
 */
export interface PairHoursAgoPriceResponse {
  /**
   *
   * @type {string}
   * @memberof PairHoursAgoPriceResponse
   */
  pairBase: string;
  /**
   *
   * @type {number}
   * @memberof PairHoursAgoPriceResponse
   */
  hoursAgo: number;
  /**
   *
   * @type {string}
   * @memberof PairHoursAgoPriceResponse
   */
  blockChain: PairHoursAgoPriceResponseBlockChainEnum;
  /**
   *
   * @type {OracleIdInput}
   * @memberof PairHoursAgoPriceResponse
   */
  oracleId: OracleIdInput;
  /**
   *
   * @type {OracleHistoryPricePoint}
   * @memberof PairHoursAgoPriceResponse
   */
  pricePoint: OracleHistoryPricePoint;
}

/**
 * @export
 * @enum {string}
 */
export enum PairHoursAgoPriceResponseBlockChainEnum {
  Monad = 'MONAD',
}

/**
 *
 * @export
 * @interface PairOverview
 */
export interface PairOverview {
  /**
   *
   * @type {string}
   * @memberof PairOverview
   */
  pairBase: string;
  /**
   *
   * @type {string}
   * @memberof PairOverview
   */
  pairName: string;
  /**
   *
   * @type {string}
   * @memberof PairOverview
   */
  pairSymbol: string;
  /**
   *
   * @type {string}
   * @memberof PairOverview
   */
  pairType: string;
  /**
   *
   * @type {string}
   * @memberof PairOverview
   */
  tradingVolumeQty: string;
  /**
   *
   * @type {string}
   * @memberof PairOverview
   */
  tradingVolumeUSD: string;
}
/**
 *
 * @export
 * @interface PairResponse
 */
export interface PairResponse {
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  base: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  pairName: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  symbol: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  pairType: PairResponsePairTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  icon?: string;
  /**
   *
   * @type {boolean}
   * @memberof PairResponse
   */
  isDegenPair: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PairResponse
   */
  tags: Array<string>;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  listAt: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  nextOpen?: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  nextClose?: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  schedule?: string;
  /**
   *
   * @type {number}
   * @memberof PairResponse
   */
  priceDisplayDecimals: number;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  status: PairResponseStatusEnum;
  /**
   *
   * @type {number}
   * @memberof PairResponse
   */
  minHoldingSeconds: number;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  holdingTimeThresholdSizeUSD: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  pythPriceFeedId: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  pythProPriceFeedId?: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  pythSymbol: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  volume: string;
  /**
   *
   * @type {string}
   * @memberof PairResponse
   */
  volumeUSD: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PairResponsePairTypeEnum {
  Crypto = 'CRYPTO',
  Stocks = 'STOCKS',
  Forex = 'FOREX',
  Indices = 'INDICES',
  Commodities = 'COMMODITIES',
}
/**
 * @export
 * @enum {string}
 */
export enum PairResponseStatusEnum {
  Available = 'AVAILABLE',
  ReduceOnly = 'REDUCE_ONLY',
  Close = 'CLOSE',
}

/**
 *
 * @export
 * @interface PairVolumeResponse
 */
export interface PairVolumeResponse {
  /**
   *
   * @type {string}
   * @memberof PairVolumeResponse
   */
  pairBase: string;
  /**
   *
   * @type {number}
   * @memberof PairVolumeResponse
   */
  volume: number;
  /**
   *
   * @type {number}
   * @memberof PairVolumeResponse
   */
  volumeUSD: number;
  /**
   *
   * @type {string}
   * @memberof PairVolumeResponse
   */
  period: PairVolumeResponsePeriodEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum PairVolumeResponsePeriodEnum {
  OneDay = 'ONE_DAY',
  SevenDay = 'SEVEN_DAY',
  ThirtyDay = 'THIRTY_DAY',
  All = 'ALL',
}

/**
 *
 * @export
 * @interface PnlChartDataEntry
 */
export interface PnlChartDataEntry {
  /**
   *
   * @type {number}
   * @memberof PnlChartDataEntry
   */
  t: number;
  /**
   *
   * @type {string}
   * @memberof PnlChartDataEntry
   */
  pnl: string;
}
/**
 *
 * @export
 * @interface PnlChartDataResponse
 */
export interface PnlChartDataResponse {
  /**
   *
   * @type {Array<PnlChartDataEntry>}
   * @memberof PnlChartDataResponse
   */
  data: Array<PnlChartDataEntry>;
  /**
   *
   * @type {string}
   * @memberof PnlChartDataResponse
   */
  updatedAt: string;
  /**
   *
   * @type {string}
   * @memberof PnlChartDataResponse
   */
  resolution: PnlChartDataResponseResolutionEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum PnlChartDataResponseResolutionEnum {
  _1 = 'DAY_1',
  _7 = 'DAY_7',
  _30 = 'DAY_30',
}

/**
 *
 * @export
 * @interface PortfolioResponse
 */
export interface PortfolioResponse {
  /**
   *
   * @type {string}
   * @memberof PortfolioResponse
   */
  trader: string;
  /**
   *
   * @type {string}
   * @memberof PortfolioResponse
   */
  realizedPNL: string;
  /**
   *
   * @type {string}
   * @memberof PortfolioResponse
   */
  realizedPNLAfterFees: string;
  /**
   *
   * @type {string}
   * @memberof PortfolioResponse
   */
  tradingVolumeUSD: string;
  /**
   *
   * @type {number}
   * @memberof PortfolioResponse
   */
  gain: number;
  /**
   *
   * @type {number}
   * @memberof PortfolioResponse
   */
  loss: number;
  /**
   *
   * @type {Metrics}
   * @memberof PortfolioResponse
   */
  metrics: Metrics;
  /**
   *
   * @type {Array<PairOverview>}
   * @memberof PortfolioResponse
   */
  tradingPairs: Array<PairOverview>;
}
/**
 *
 * @export
 * @interface PositionOraclePriceRequest
 */
export interface PositionOraclePriceRequest {
  /**
   *
   * @type {string}
   * @memberof PositionOraclePriceRequest
   */
  pairBase: string;
  /**
   *
   * @type {string}
   * @memberof PositionOraclePriceRequest
   */
  collateral: string;
  /**
   *
   * @type {string}
   * @memberof PositionOraclePriceRequest
   */
  blockChain: PositionOraclePriceRequestBlockChainEnum;
  /**
   *
   * @type {OracleResponseOptions}
   * @memberof PositionOraclePriceRequest
   */
  options: OracleResponseOptions;
}

/**
 * @export
 * @enum {string}
 */
export enum PositionOraclePriceRequestBlockChainEnum {
  Monad = 'MONAD',
}

/**
 *
 * @export
 * @interface PositionOraclePythComparisonRequest
 */
export interface PositionOraclePythComparisonRequest {
  /**
   *
   * @type {string}
   * @memberof PositionOraclePythComparisonRequest
   */
  pairBase: string;
  /**
   *
   * @type {string}
   * @memberof PositionOraclePythComparisonRequest
   */
  collateral: string;
  /**
   *
   * @type {string}
   * @memberof PositionOraclePythComparisonRequest
   */
  blockChain: PositionOraclePythComparisonRequestBlockChainEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum PositionOraclePythComparisonRequestBlockChainEnum {
  Monad = 'MONAD',
}

/**
 *
 * @export
 * @interface PositionResponse
 */
export interface PositionResponse {
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  positionHash: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  pair: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  pairBase: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  trader: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  tokenIn: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  marginToken: string;
  /**
   *
   * @type {boolean}
   * @memberof PositionResponse
   */
  isLong: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  margin: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  qty: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  entryPrice: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  stopLoss: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  takeProfit: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  openFee: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  executionFee: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  longAccFundingFeePerShare: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  holdingFeeRate: string;
  /**
   *
   * @type {number}
   * @memberof PositionResponse
   */
  timestamp: number;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  status: PositionResponseStatusEnum;
  /**
   *
   * @type {CloseInfo}
   * @memberof PositionResponse
   */
  closeInfo?: CloseInfo;
}

/**
 * @export
 * @enum {string}
 */
export enum PositionResponseStatusEnum {
  Pending = 'PENDING',
  Closed = 'CLOSED',
  Cancelled = 'CANCELLED',
  Open = 'OPEN',
  Closing = 'CLOSING',
}

/**
 *
 * @export
 * @interface PythOracleComparisonResponse
 */
export interface PythOracleComparisonResponse {
  /**
   *
   * @type {number}
   * @memberof PythOracleComparisonResponse
   */
  sampledAtEpochMs: number;
  /**
   *
   * @type {string}
   * @memberof PythOracleComparisonResponse
   */
  pairBase: string;
  /**
   *
   * @type {string}
   * @memberof PythOracleComparisonResponse
   */
  collateral: string;
  /**
   *
   * @type {string}
   * @memberof PythOracleComparisonResponse
   */
  blockChain: PythOracleComparisonResponseBlockChainEnum;
  /**
   *
   * @type {Array<PythOracleLegSnapshot>}
   * @memberof PythOracleComparisonResponse
   */
  legs: Array<PythOracleLegSnapshot>;
  /**
   *
   * @type {string}
   * @memberof PythOracleComparisonResponse
   */
  oracleBatchPythCoreUpdateFeeWei?: string;
  /**
   *
   * @type {string}
   * @memberof PythOracleComparisonResponse
   */
  oracleBatchPythProVerificationFeeWei?: string;
  /**
   *
   * @type {string}
   * @memberof PythOracleComparisonResponse
   */
  oracleBatchTotalCallbackWei?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PythOracleComparisonResponseBlockChainEnum {
  Monad = 'MONAD',
}

/**
 *
 * @export
 * @interface PythOracleLegSnapshot
 */
export interface PythOracleLegSnapshot {
  /**
   *
   * @type {string}
   * @memberof PythOracleLegSnapshot
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof PythOracleLegSnapshot
   */
  pythCoreOracleId?: string;
  /**
   *
   * @type {string}
   * @memberof PythOracleLegSnapshot
   */
  pythProOracleId?: string;
  /**
   *
   * @type {string}
   * @memberof PythOracleLegSnapshot
   */
  pythCorePrice?: string;
  /**
   *
   * @type {string}
   * @memberof PythOracleLegSnapshot
   */
  pythProPrice?: string;
  /**
   *
   * @type {number}
   * @memberof PythOracleLegSnapshot
   */
  pythCorePublishTimeEpochSec?: number;
  /**
   *
   * @type {number}
   * @memberof PythOracleLegSnapshot
   */
  pythProPublishTimeEpochSec?: number;
  /**
   *
   * @type {number}
   * @memberof PythOracleLegSnapshot
   */
  pythCoreStalenessSeconds?: number;
  /**
   *
   * @type {number}
   * @memberof PythOracleLegSnapshot
   */
  pythProStalenessSeconds?: number;
  /**
   *
   * @type {number}
   * @memberof PythOracleLegSnapshot
   */
  stalenessImprovementProVsCoreSeconds?: number;
  /**
   *
   * @type {string}
   * @memberof PythOracleLegSnapshot
   */
  priceDiffProMinusCoreBps?: string;
}
/**
 *
 * @export
 * @interface RefundDetail
 */
export interface RefundDetail {
  /**
   *
   * @type {string}
   * @memberof RefundDetail
   */
  refund: RefundDetailRefundEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum RefundDetailRefundEnum {
  No = 'NO',
  Switch = 'SWITCH',
  PairStatus = 'PAIR_STATUS',
  AmountIn = 'AMOUNT_IN',
  UserPrice = 'USER_PRICE',
  MinNotionalUsd = 'MIN_NOTIONAL_USD',
  MaxNotionalUsd = 'MAX_NOTIONAL_USD',
  MaxLeverage = 'MAX_LEVERAGE',
  Tp = 'TP',
  Sl = 'SL',
  PairOi = 'PAIR_OI',
  OpenLost = 'OPEN_LOST',
  System = 'SYSTEM',
  FeedDelay = 'FEED_DELAY',
  PriceProtection = 'PRICE_PROTECTION',
}

/**
 *
 * @export
 * @interface SlvmonUserPortfolioDto
 */
export interface SlvmonUserPortfolioDto {
  /**
   *
   * @type {string}
   * @memberof SlvmonUserPortfolioDto
   */
  shares: string;
  /**
   *
   * @type {string}
   * @memberof SlvmonUserPortfolioDto
   */
  principal: string;
  /**
   *
   * @type {string}
   * @memberof SlvmonUserPortfolioDto
   */
  cumulativeRealizedPnl: string;
}
/**
 *
 * @export
 * @interface TeamInfo
 */
export interface TeamInfo {
  /**
   *
   * @type {string}
   * @memberof TeamInfo
   */
  teamName: string;
  /**
   *
   * @type {string}
   * @memberof TeamInfo
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof TeamInfo
   */
  totalGeneralPoints: string;
  /**
   *
   * @type {string}
   * @memberof TeamInfo
   */
  totalDegenPoints: string;
  /**
   *
   * @type {number}
   * @memberof TeamInfo
   */
  teamMemberCount: number;
  /**
   *
   * @type {EpochTrading}
   * @memberof TeamInfo
   */
  latestEpochTrading: EpochTrading;
}
/**
 *
 * @export
 * @interface TeamLeaderboardItem
 */
export interface TeamLeaderboardItem {
  /**
   *
   * @type {string}
   * @memberof TeamLeaderboardItem
   */
  teamName: string;
  /**
   *
   * @type {string}
   * @memberof TeamLeaderboardItem
   */
  currentEpochVolume: string;
  /**
   *
   * @type {string}
   * @memberof TeamLeaderboardItem
   */
  currentGeneralPoints: string;
  /**
   *
   * @type {string}
   * @memberof TeamLeaderboardItem
   */
  currentDegenPoints: string;
}
/**
 *
 * @export
 * @interface TeamMemberInfo
 */
export interface TeamMemberInfo {
  /**
   *
   * @type {string}
   * @memberof TeamMemberInfo
   */
  member: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberInfo
   */
  joinDate: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberInfo
   */
  cumulativeVolumeUSD: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberInfo
   */
  cumulativeGeneralPointsToLeader: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberInfo
   */
  cumulativeDegenPointsToLeader: string;
}
/**
 *
 * @export
 * @interface TradeHistoryResponse
 */
export interface TradeHistoryResponse {
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  transactionHash: string;
  /**
   *
   * @type {number}
   * @memberof TradeHistoryResponse
   */
  blockNumber: number;
  /**
   *
   * @type {number}
   * @memberof TradeHistoryResponse
   */
  transactionIndex: number;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  hash: string;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  positionHash?: string;
  /**
   *
   * @type {number}
   * @memberof TradeHistoryResponse
   */
  logIndex: number;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  pairBase: string;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  qty: string;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  tradeType: TradeHistoryResponseTradeTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  operationType: TradeHistoryResponseOperationTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  blockTime: string;
  /**
   *
   * @type {boolean}
   * @memberof TradeHistoryResponse
   */
  isLong: boolean;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  tokenIn: string;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  lvToken: string;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  amountIn: string;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  margin?: string;
  /**
   *
   * @type {string}
   * @memberof TradeHistoryResponse
   */
  tokenInPrice?: string;
  /**
   *
   * @type {PositionResponse}
   * @memberof TradeHistoryResponse
   */
  position?: PositionResponse;
  /**
   *
   * @type {TradeHistoryResponseDetail}
   * @memberof TradeHistoryResponse
   */
  detail?: TradeHistoryResponseDetail;
}

/**
 * @export
 * @enum {string}
 */
export enum TradeHistoryResponseTradeTypeEnum {
  Order = 'ORDER',
  Position = 'POSITION',
}
/**
 * @export
 * @enum {string}
 */
export enum TradeHistoryResponseOperationTypeEnum {
  OpenLimitOrder = 'OPEN_LIMIT_ORDER',
  UpdateOrderSl = 'UPDATE_ORDER_SL',
  UpdateOrderTp = 'UPDATE_ORDER_TP',
  CancelLimitOrder = 'CANCEL_LIMIT_ORDER',
  LimitOrderRefund = 'LIMIT_ORDER_REFUND',
  ExecuteLimitOrderSuccessful = 'EXECUTE_LIMIT_ORDER_SUCCESSFUL',
  ExecuteLimitOrderRejected = 'EXECUTE_LIMIT_ORDER_REJECTED',
  OpenMarketTrade = 'OPEN_MARKET_TRADE',
  OpenPosition = 'OPEN_POSITION',
  PositionIncreased = 'POSITION_INCREASED',
  ClosePosition = 'CLOSE_POSITION',
  PositionDecreased = 'POSITION_DECREASED',
  UpdateMargin = 'UPDATE_MARGIN',
  UpdateTradeSl = 'UPDATE_TRADE_SL',
  UpdateTradeTp = 'UPDATE_TRADE_TP',
  PendingTradeRefund = 'PENDING_TRADE_REFUND',
  MarketPendingTrade = 'MARKET_PENDING_TRADE',
  ExecuteCloseRejected = 'EXECUTE_CLOSE_REJECTED',
  CloseTradeSuccessful = 'CLOSE_TRADE_SUCCESSFUL',
  ExecuteCloseSuccessful = 'EXECUTE_CLOSE_SUCCESSFUL',
  ExecuteDecreaseOrderSuccessful = 'EXECUTE_DECREASE_ORDER_SUCCESSFUL',
  DecreaseOrderCreated = 'DECREASE_ORDER_CREATED',
  DecreaseOrderCancelled = 'DECREASE_ORDER_CANCELLED',
  DecreaseOrderUpdated = 'DECREASE_ORDER_UPDATED',
}

/**
 * @type TradeHistoryResponseDetail
 *
 * @export
 */
export type TradeHistoryResponseDetail =
  | ClosePositionDetail
  | LimitOrderPositionDetail
  | MarketOrderPositionDetail
  | MarketPendingDetail
  | RefundDetail
  | UpdateMarginDetail
  | UpdateSlDetail
  | UpdateTpDetail;
/**
 *
 * @export
 * @interface TradeOverviewResponse
 */
export interface TradeOverviewResponse {
  /**
   *
   * @type {string}
   * @memberof TradeOverviewResponse
   */
  realizedPnlUsd: string;
  /**
   *
   * @type {string}
   * @memberof TradeOverviewResponse
   */
  biggestWinUsd?: string;
  /**
   *
   * @type {number}
   * @memberof TradeOverviewResponse
   */
  winRate: number;
  /**
   *
   * @type {string}
   * @memberof TradeOverviewResponse
   */
  updatedAt: string;
}
/**
 *
 * @export
 * @interface TradingCompetitionLeaderboardItem
 */
export interface TradingCompetitionLeaderboardItem {
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionLeaderboardItem
   */
  trader: string;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof TradingCompetitionLeaderboardItem
   */
  stats: { [key: string]: number };
}
/**
 *
 * @export
 * @interface TradingCompetitionLeaderboardResponse
 */
export interface TradingCompetitionLeaderboardResponse {
  /**
   *
   * @type {Array<LeaderboardHeader>}
   * @memberof TradingCompetitionLeaderboardResponse
   */
  headers: Array<LeaderboardHeader>;
  /**
   *
   * @type {PagedTradingCompetitionLeaderboardItem}
   * @memberof TradingCompetitionLeaderboardResponse
   */
  data: PagedTradingCompetitionLeaderboardItem;
}
/**
 *
 * @export
 * @interface TradingCompetitionResponse
 */
export interface TradingCompetitionResponse {
  /**
   *
   * @type {number}
   * @memberof TradingCompetitionResponse
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  banner?: string;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  ruleLink?: string;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  ruleId?: string;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  leaderboardType?: TradingCompetitionResponseLeaderboardTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  rewardAmount?: string;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  rewardTokenAddress?: string;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  rewardType?: TradingCompetitionResponseRewardTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  rewardDescription?: string;
  /**
   *
   * @type {number}
   * @memberof TradingCompetitionResponse
   */
  startTime: number;
  /**
   *
   * @type {number}
   * @memberof TradingCompetitionResponse
   */
  endTime: number;
  /**
   *
   * @type {number}
   * @memberof TradingCompetitionResponse
   */
  currentParticipants: number;
  /**
   *
   * @type {number}
   * @memberof TradingCompetitionResponse
   */
  tradingVolume: number;
  /**
   *
   * @type {boolean}
   * @memberof TradingCompetitionResponse
   */
  isReadyToDisplay: boolean;
  /**
   *
   * @type {string}
   * @memberof TradingCompetitionResponse
   */
  status: TradingCompetitionResponseStatusEnum;
  /**
   *
   * @type {boolean}
   * @memberof TradingCompetitionResponse
   */
  hasJoined: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum TradingCompetitionResponseLeaderboardTypeEnum {
  Default = 'DEFAULT',
  PnlBased = 'PNL_BASED',
  TotalVolumeBased = 'TOTAL_VOLUME_BASED',
  LowLeverageVolumeBased = 'LOW_LEVERAGE_VOLUME_BASED',
  HighLeverageVolumeBased = 'HIGH_LEVERAGE_VOLUME_BASED',
}
/**
 * @export
 * @enum {string}
 */
export enum TradingCompetitionResponseRewardTypeEnum {
  Token = 'TOKEN',
}
/**
 * @export
 * @enum {string}
 */
export enum TradingCompetitionResponseStatusEnum {
  Upcoming = 'UPCOMING',
  Ongoing = 'ONGOING',
  Ended = 'ENDED',
}

/**
 *
 * @export
 * @interface TradingVolumeResponse
 */
export interface TradingVolumeResponse {
  /**
   *
   * @type {string}
   * @memberof TradingVolumeResponse
   */
  userAddress: string;
  /**
   *
   * @type {string}
   * @memberof TradingVolumeResponse
   */
  tradeDate: string;
  /**
   *
   * @type {number}
   * @memberof TradingVolumeResponse
   */
  dailyVolume: number;
  /**
   *
   * @type {number}
   * @memberof TradingVolumeResponse
   */
  openCount: number;
  /**
   *
   * @type {number}
   * @memberof TradingVolumeResponse
   */
  closeCount: number;
  /**
   *
   * @type {number}
   * @memberof TradingVolumeResponse
   */
  openVolume: number;
  /**
   *
   * @type {number}
   * @memberof TradingVolumeResponse
   */
  closeVolume: number;
}
/**
 *
 * @export
 * @interface TradingVolumeSummaryResponse
 */
export interface TradingVolumeSummaryResponse {
  /**
   *
   * @type {number}
   * @memberof TradingVolumeSummaryResponse
   */
  vol: number;
  /**
   *
   * @type {number}
   * @memberof TradingVolumeSummaryResponse
   */
  usdVol: number;
}
/**
 *
 * @export
 * @interface UpdateMarginDetail
 */
export interface UpdateMarginDetail {
  /**
   *
   * @type {string}
   * @memberof UpdateMarginDetail
   */
  beforeMargin: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMarginDetail
   */
  margin: string;
}
/**
 *
 * @export
 * @interface UpdateSlDetail
 */
export interface UpdateSlDetail {
  /**
   *
   * @type {string}
   * @memberof UpdateSlDetail
   */
  oldSl: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSlDetail
   */
  sl: string;
}
/**
 *
 * @export
 * @interface UpdateTpDetail
 */
export interface UpdateTpDetail {
  /**
   *
   * @type {string}
   * @memberof UpdateTpDetail
   */
  oldTp: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTpDetail
   */
  tp: string;
}
/**
 *
 * @export
 * @interface UserTeamBoostHistory
 */
export interface UserTeamBoostHistory {
  /**
   *
   * @type {number}
   * @memberof UserTeamBoostHistory
   */
  epoch: number;
  /**
   *
   * @type {string}
   * @memberof UserTeamBoostHistory
   */
  generalTeamBoostPoints: string;
  /**
   *
   * @type {string}
   * @memberof UserTeamBoostHistory
   */
  degenTeamBoostPoints: string;
}
/**
 *
 * @export
 * @interface UserTeamInfo
 */
export interface UserTeamInfo {
  /**
   *
   * @type {TeamInfo}
   * @memberof UserTeamInfo
   */
  leaderTeam?: TeamInfo;
  /**
   *
   * @type {TeamInfo}
   * @memberof UserTeamInfo
   */
  memberTeam?: TeamInfo;
}
